import { baseRoute } from '../../../../constants/routes';

export const TEXT_ANSWERS_ROUTE = baseRoute + '/text-answers';
export const BIND_TYPE_TEXT_ANSWERS_ROUTE = baseRoute + '/person-type-answer/';